import { render } from "./StaffEditPage.vue?vue&type=template&id=03c778a6&scoped=true"
import script from "./StaffEditPage.vue?vue&type=script&lang=js"
export * from "./StaffEditPage.vue?vue&type=script&lang=js"

import "./StaffEditPage.vue?vue&type=style&index=0&id=03c778a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c778a6"]])

export default __exports__